export interface ItemGroup {
  id: string;
  code: string;
  name: string;
  itemType: string;
  isActive: boolean;
  createdAt?: string;
  updatedAt?: string;
}

export interface ItemGroupFormData {
  code: string;
  name: string;
  itemType: string;
  isActive: boolean;
}

// Available item types
export const itemTypes = [
  'Inventory',
  'Service'
];
